import { useClientContext } from "@hooks/index";
import { applyStatusToleranceToManagement } from "@module/utils/statusTolerance";
import { useQuery } from "@tanstack/react-query";
import { getManagement } from "./index";

export const useGetManagement = (date: Date, enabled = true) => {
  const customFetch = useClientContext();

  return useQuery({
    queryKey: ["timeline", date],
    retry: false,
    refetchInterval: 20000,
    refetchIntervalInBackground: true,
    queryFn: () => getManagement(customFetch)(date),
    enabled: Boolean(date) && enabled,
    select: applyStatusToleranceToManagement,
  });
};
